import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DsModalComponent } from 'design-system';
import { Observable } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { KrsEntry } from 'src/app/models/krs-entry/krs-entry.model';
import { KrsErrorModel } from 'src/app/models/krs-error.model';
import { StatusSubskrypcji } from 'src/app/models/status-subskrypcji.enum';
import { EformsService } from 'src/app/services/eforms.service';
import { FormGroupService } from 'src/app/services/form-group.service';
import { FormMapService } from 'src/app/services/form-map.service';
import { NewsletterService } from 'src/app/services/newsletter.service';
import { environment } from 'src/environments/environment';
import { DestroyComponent } from '../destroy/destroy.component';
import { DanePodmiotuService } from './dane-podmiotu.service';

@Component({
  selector: 'app-dane-podmiotu',
  templateUrl: './dane-podmiotu.component.html',
  styleUrls: ['./dane-podmiotu.component.scss'],
})
export class DanePodmiotuComponent extends DestroyComponent implements OnInit {
  @ViewChild('modal', { static: true }) modalContainer: DsModalComponent;
  @Input() hideAdd: boolean;
  searchControl = new FormControl(null);
  podmiot$: Observable<KrsEntry>;
  loading$: Observable<boolean>;
  errorMessage$: Observable<KrsErrorModel>;
  nazwaPodmiotu: string;
  monitorowaniePodmiotuForm: FormGroup;
  openOverlay: boolean;
  activeSubscriptions: number = 0;
  maxSubscriptions: number;
  isCollapsed: boolean = false;
  wyszukiwarkaUrl = `<a target="_balnk" href="${environment.wyszukiwarkaUrl}">Wyszukiwarki KRS</a>`;

  constructor(
    private danePodmiotuService: DanePodmiotuService,
    private formGroupService: FormGroupService,
    private eformsService: EformsService,
    private formMapService: FormMapService,
    private newsletterService: NewsletterService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getPodmiot();
    this.getLoading();
    this.getErrorMessage();
    this.initActiveSubscriptions();
    this.initMaxSubscriptions();
    this.initNameSubscription();

    this.searchControl.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged((p, c) => this.danePodmiotuService.normalizeKRS(p) === this.danePodmiotuService.normalizeKRS(c)))
      .subscribe(() => this.danePodmiotuService.clearPodmiot());
  }

  handleSearch() {
    const krs = this.searchControl.value;
    this.eformsService
      .czyMoznaDodac(this.formMapService.mapNaglowek(krs))
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.danePodmiotuService.search(krs);
      });
  }

  add() {
    this.modalContainer.enableModal();
    this.monitorowaniePodmiotuForm =
      this.formGroupService.getMonitorowaniePodmiotuGroup();
    this.monitorowaniePodmiotuForm.get('nazwaPodmiotuSub').setValue(this.nazwaPodmiotu);
  }

  save(formGroup: FormGroup) {
    this.hideModal();
    this.newsletterService.loading$.next(true);
    this.eformsService
      .dodajSubskrypcje(this.formMapService.mapSubskrypcja(formGroup.getRawValue(), this.searchControl.value))
      .subscribe(() => {
        this.newsletterService.initSubskrypcje();
        this.searchControl.reset();
      }, (error) => {
        this.newsletterService.initSubskrypcje();
      });
    }

  hideModal() {
    this.modalContainer.disableModal();
    this.monitorowaniePodmiotuForm = null;
  }

  get isButtonDisabled(): boolean {
    return !this.searchControl.value;
  }

  private getPodmiot(): void {
    this.podmiot$ = this.danePodmiotuService.getPodmiotObs();
  }

  private getLoading(): void {
    this.loading$ = this.danePodmiotuService.getLoadingObs();
  }

  private getErrorMessage(): void {
    this.errorMessage$ = this.danePodmiotuService.getErrorMessageObs();
  }

  private initNameSubscription(): void {
    this.podmiot$.subscribe(val => {
      this.nazwaPodmiotu = val?.dzial1?.danePodmiotu?.nazwa;
    });
  }

  private initActiveSubscriptions(): void {
    this.newsletterService.subskrypcjeUzytkownika$.subscribe(val => {
      this.activeSubscriptions = val.filter((subskrypcja) =>
        [
          StatusSubskrypcji.AKTYWNA,
          StatusSubskrypcji.WYGASAJACA,
          StatusSubskrypcji.ZAMOWIONA,
        ].includes(subskrypcja.subskrypcja.status as StatusSubskrypcji)
      ).length;

      if (this.hideAdd != null) {
        this.isCollapsed = this.hideAdd;
      } else {
        this.isCollapsed =  val.length > 0;
      }
    });
  }

  private initMaxSubscriptions(): void {
    this.newsletterService.konfiguracja$.subscribe(val => {
      this.maxSubscriptions = val?.maxLiczbaSubskrypcji;
    });
  }
}
